import React from "react";
import "./notfound.scss";

export default function NotFound() {
    return <div>404 - Page Not Found / Page is Under Construction.</div>;
}
